export { OwnershipFacet } from './OwnershipFacet';
export type { OwnershipFacetProps } from './OwnershipFacet.types';
